import React from 'react';
import {Link, Navigate} from 'react-router-dom';
import {PRIMARY_COLOR} from "../contants/Colors";
import {useAuth} from "../context/AuthContext";

export default function LandingPage() {

  const { user, isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return <Navigate to={user?.role === 'tenant' ? '/tenant/dashboard' : '/feedback-taker/dashboard'} replace />;
  }

  return (
      <div className="page" style={{
        background: 'linear-gradient(135deg, rgb(255,46,88) 0%, rgb(59,28,98) 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}>
        <video className="bg-video desktop" autoPlay muted loop playsInline>
          <source src="https://pub-267dd4744ace49cf8306de8e7c530c15.r2.dev/assets/PPBack.mp4" type="video/mp4"/>
        </video>

        <video className="bg-video mobile" autoPlay muted loop playsInline>
          <source src="https://pub-267dd4744ace49cf8306de8e7c530c15.r2.dev/assets/PPBack_M.mp4" type="video/mp4"/>
        </video>

        <div className="overlay"></div>

        <div className={'content'} style={{textAlign: 'center', color: '#fff', padding: '40px 24px'}}>
          <img src={'https://pub-267dd4744ace49cf8306de8e7c530c15.r2.dev/assets/Logo-White.png'}
               style={{width: '40vw', minWidth: 150, maxWidth: 200, marginBottom: 12}}/>
          <p style={{fontSize: 18, opacity: 0.85, marginBottom: 40, maxWidth: 480, margin: '0 auto 40px'}}>
            Collect interactive and audio feedback from your customers - fast, simple, and insightful.
          </p>
          <div style={{display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap'}}>
            <div style={{background: 'rgba(255,255,255,0.12)', borderRadius: 16, padding: '32px 40px', minWidth: 220}}>
              <div style={{fontSize: 36, marginBottom: 12}}>🏢</div>
              <h3 style={{marginBottom: 8, color: '#fff'}}>I'm a Tenant</h3>
              <p style={{opacity: 0.75, fontSize: 14, marginBottom: 20}}>Manage your team and view feedback
                analytics</p>
              <Link to="/tenant/login" className="btn btn-lg" style={{
                background: '#fff',
                color: PRIMARY_COLOR,
                width: '100%',
                justifyContent: 'center',
                marginBottom: 12
              }}>Tenant Login</Link>
              {/*<div style={{ marginTop: 10 }}>*/}
              {/*  <Link to="/tenant/register" style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13 }}>New? Register here →</Link>*/}
              {/*</div>*/}
            </div>
            <div style={{background: 'rgba(255,255,255,0.12)', borderRadius: 16, padding: '32px 40px', minWidth: 220}}>
              <div style={{fontSize: 36, marginBottom: 12}}>👤</div>
              <h3 style={{marginBottom: 8, color: '#fff'}}>I'm a Feedback Taker</h3>
              <p style={{opacity: 0.75, fontSize: 14, marginBottom: 20}}>Create sessions and collect customer
                feedback</p>
              <Link to="/feedback-taker/login" className="btn btn-lg" style={{
                background: '#fff',
                color: PRIMARY_COLOR,
                width: '100%',
                justifyContent: 'center',
                marginBototm: 12
              }}>Staff Login</Link>
            </div>
          </div>
        </div>
      </div>
  );
}
